<template>
  <div>
    <v-col class="color-title">
      <v-row justify="center" class="black pt-3 pb-2" no-gutters>
        <strong>{{
            response.cliente.razao_social + " (CÓDIGO: " + response.cliente.codigo + ")"
          }}</strong>
        <strong class="px-1 cor-paleta">/</strong>
        <span>
          Total vendido: {{ receberResponse.total_parcela }} |
          Total pago: {{ receberResponse.total_recebido }} |
          Total em aberto: {{ receberResponse.total_aberto }}
        </span>
        <strong class="px-1 cor-paleta">/</strong>
        <span>
          Esfera: {{ response.cliente.esfera }}
        </span>
        <strong class="px-1 cor-paleta">/</strong>
        <span v-if="response.endereco">
          UF: {{ response.endereco.estado }}
        </span>
      </v-row>
    </v-col>
    <v-row justify-center>
      <v-col class="pl-0 pb-0">
        <v-row class="justify-center">
          <v-col class="py-0" cols="12" md="2" sm="4">
            <v-autocomplete
                class="nomessage"
                label="Tipo Data"
                :items="listas.tiposDatas"
                item-text="descricao"
                item-value="id"
                v-model="filtroReceber.data_filtro"
                clearable
                v-on:keyup.enter="buscarNotasDocumentos(false)"
            ></v-autocomplete>
          </v-col>
          <v-col class="py-0" cols="12" md="2" sm="4">
            <date-picker-component class="nomessage" :key="keyDataInicio" label="Data Início"
                                   v-bind:data.sync="filtroReceber.data_inicio">
            </date-picker-component>
          </v-col>
          <v-col class="py-0" cols="12" md="2" sm="4">
            <date-picker-component class="nomessage" :key="keyDataFim" label="Data Fim"
                                   v-bind:data.sync="filtroReceber.data_fim">
            </date-picker-component>
          </v-col>
          <v-col class="py-0" cols="12" md="2" sm="6">
            <v-select
                class="nomessage"
                label="Período (dias)"
                :items="listas.periodos"
                item-text="descricao"
                item-value="id"
                v-on:keyup.enter="buscarNotasDocumentos(false)"
                v-model="filtroReceber.dias_posicao"
                clearable
            ></v-select>
          </v-col>
          <v-col class="py-0 pr-0" cols="12" md="3" sm="6">
            <v-select
                class="nomessage"
                label="Setor"
                :items="listas.setores"
                item-text="descricao"
                item-value="id"
                v-on:keyup.enter="buscarNotasDocumentos(false)"
                v-model="filtroReceber.posicao"
                clearable
            ></v-select>
          </v-col>
        </v-row>
        <v-row class="justify-center">
          <v-col class="nomessage py-0" cols="12" md="2" sm="4">
            <v-text-field v-model="filtroReceber.Núm_NF" label="Nota"
                          v-on:keyup.enter="buscarNotasDocumentos(false)"/>
          </v-col>
          <v-col class="py-0" cols="12" md="2" sm="4">
            <v-text-field class="nomessage" v-model="filtroReceber.num_empenho" label="Empenho"
                          v-on:keyup.enter="buscarNotasDocumentos(false)"/>
          </v-col>
          <v-col class="nomessage py-0" cols="12" md="2" sm="4">
            <v-text-field v-model="filtroReceber.num_pregao" label="Pregão"
                          v-on:keyup.enter="buscarNotasDocumentos(false)"/>
          </v-col>
          <v-col class="py-0" cols="12" md="2" sm="4">
            <v-text-field class="nomessage" v-model="filtroReceber.codigo_contrato" label="Contrato"
                          v-on:keyup.enter="buscarNotasDocumentos(false)"/>
          </v-col>
          <v-col class="nomessage py-0 pr-0" cols="12" md="3" sm="4">
            <v-text-field v-model="filtroReceber.Documento" label="Documento"
                          v-on:keyup.enter="buscarNotasDocumentos(false)"/>
          </v-col>
        </v-row>
        <v-row class="justify-center">
          <v-col class="pr-0 pt-6 pb-2 pl-2" cols="4">
            <v-checkbox v-model="checkNexomed" label="Nexo"
                        class="mt-0 mr-3 check-nomessage d-inline-flex"/>
            <v-checkbox v-model="checkBml" label="BML"
                        class="mt-0 mr-3 check-nomessage d-inline-flex"/>
            <v-checkbox v-model="checkPendente" label="Pendente"
                        class="mt-0 check-nomessage d-inline-flex"/>
            <v-icon class="pb-2 mr-3 ml-1" small>mdi-minus-circle-outline</v-icon>
            <v-checkbox v-model="checkPago" label="Pago"
                        class="mt-0 check-nomessage d-inline-flex"/>
            <v-icon class="pb-2 ml-1" small>mdi-check-circle-outline</v-icon>
          </v-col>
          <v-col class="py-0" cols="12" md="2" sm="4">
            <v-select label="Classificação" v-on:keyup.enter="buscarNotasDocumentos(false)"
                      :items="listas.classificacoesTitulo" clearable class="nomessage"
                      item-text="descricao" item-value="id" v-model="filtroReceber.classificacao"/>
          </v-col>
          <v-col class="py-0" cols="12" md="2" sm="4">
            <v-select label="Marcador" v-on:keyup.enter="buscarNotasDocumentos(false)"
                      :items="listas.marcadores" clearable class="nomessage"
                      item-text="descricao" item-value="id" v-model="filtroReceber.marcador_contrato"/>
          </v-col>
          <v-col class="pa-0 pt-7 pl-3 text-right" cols="12" md="3" sm="2">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="mr-3" color="primary" v-bind="attrs"
                        v-on="on" @click="buscarNotasDocumentos(false)">
                  mdi-magnify
                </v-icon>
              </template>
              <span>Localizar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="mr-3" color="primary" v-bind="attrs"
                        v-on="on" @click="limpar">
                  mdi-close-outline
                </v-icon>
              </template>
              <span>Limpar filtros</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="mr-3" v-bind="attrs" color="primary"
                        v-on="on" @click="goSync">
                  mdi-cloud-download
                </v-icon>
              </template>
              <span>Sincronizar Documentos / Régua</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="mr-3" color="primary" v-bind="attrs"
                        v-on="on" @click="goMover">
                  mdi-arrow-collapse-right
                </v-icon>
              </template>
              <span>Mover selecionado(s)</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="primary" v-bind="attrs"
                        v-on="on" @click="goHistorico">
                  mdi-format-list-bulleted
                </v-icon>
              </template>
              <span>Visualizar histórico</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-card>
      <v-data-table :headers="headers"
                    v-model="itensSelecionados"
                    :items="receberResponse.itens"
                    item-key="Núm_NF" show-select
                    :item-class="itemRowBackground">

        <template v-slot:[`item.Empresa`]="{ item }">
          <v-icon>
            {{ item.status_pagamento === 'PAGO' ? 'mdi-check-circle-outline' : 'mdi-minus-circle-outline' }}
          </v-icon>
          <span class="ml-2">{{ item.Empresa }}</span>
        </template>

        <template v-slot:[`item.range_tipo`]="{ item }">
          <v-tooltip bottom color="primary">
            <template v-slot:activator="{ on, attrs }">
              <td v-bind="attrs" v-on="on" class="alinharColuna">
                <v-icon :color="periodoUtil.setColor(item.range_tipo)">
                  {{ periodoUtil.setIcon(item.range_tipo) }}
                </v-icon>
                <span class="pl-1">{{ item.range }}</span>
              </td>
            </template>
            <span>{{ periodoUtil.setTooltip(item.range_tipo) }}</span>
          </v-tooltip>
        </template>

      </v-data-table>
    </v-card>

    <!--    MODAL DE HISTÓRICO DA RÉGUA -->
    <v-dialog persistent v-model="showDialogHistorico" width="500">
      <v-card color="clean">
        <v-card-title class="pa-4">
          <h2>Histórico da Régua</h2>
        </v-card-title>
        <v-card-text class="px-4 py-0" style="color: black;">
          <v-list class="pa-3 mb-3 borda-listagem" two-line>
            <template v-for="(item, index) in historico">
              <v-list-item class="pa-0">
                <v-list-item-content class="pa-0">
                  <v-list-item-title>
                    <h3><b>Usuário: {{ item.nome_usuario }}</b></h3>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <h4 v-if="item.nome_posicao_anterior" class="texto-inline"><b>De: </b></h4>
                    <h4 v-else class="texto-inline">Início: </h4>{{ item.nome_posicao_anterior }}
                    <h4 v-if="item.nome_posicao_anterior" class="texto-inline"><b> | Para: </b></h4>
                    {{ item.nome_posicao }}
                    <br>
                    <h4 class="texto-inline"><b>Data entrada: </b></h4>{{ formataDataVisualizacao(item.data_entrada) }}
                    <h4 v-if="item.data_saida" class="texto-inline"> | <b>Data saída: </b></h4>
                    {{ formataDataVisualizacao(item.data_saida) }}
                    <br>
                    <h4 class="texto-inline"><b>Dias no Setor: </b></h4>
                    {{ item.dias_posicao }} <br>
                    <h4 class="texto-inline obs_text"><b>Observação: </b></h4><span
                      v-html="item.observacoes ? item.observacoes : '-'"></span>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="my-1" v-if="index < historico.length - 1" :key="index"></v-divider>
            </template>
          </v-list>
        </v-card-text>
        <v-card-actions class="justify-end pa-4 pt-0">
          <v-btn color="clean" style="color: white;" @click="showDialogHistorico = false">
            <v-icon>mdi-close</v-icon>
            <b>Cancelar</b>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--    MODAL DE MOVER NOTAS PARA OUTRO SETOR -->
    <v-dialog persistent v-model="showDialogMover" width="1300">
      <v-card>
        <v-card-title class="pa-4 word-white">
          <h2>Mover Nota</h2>
        </v-card-title>
        <v-card-text class="px-4 py-0">
          <v-stepper v-model="step" class="primary">
            <v-stepper-header>
              <v-stepper-step editable :class="step === '1' ? 'step-selected': 'step-option'" step="1" color="black">
                <strong :class="step === '1' ? 'word-black' : 'word-white'"><b>Envio/Cirurgia</b></strong>
              </v-stepper-step>
              <v-divider color="white"/>
              <v-stepper-step editable :class="step === '2' ? 'step-selected': 'step-option'" step="2" color="black">
                <strong :class="step === '2' ? 'word-black' : 'word-white'"><b>Alm/B.C Entrega</b></strong>
              </v-stepper-step>
              <v-divider color="white"/>
              <v-stepper-step editable :class="step === '3' ? 'step-selected': 'step-option'" step="3" color="black">
                <strong :class="step === '3' ? 'word-black' : 'word-white'"><b>Alm/B.C Processo</b></strong>
              </v-stepper-step>
              <v-divider color="white"/>
              <v-stepper-step editable :class="step === '4' ? 'step-selected': 'step-option'" step="4" color="black">
                <strong :class="step === '4' ? 'word-black' : 'word-white'"><b>Cont. Liquidação</b></strong>
              </v-stepper-step>
              <v-divider color="white"/>
              <v-stepper-step editable :class="step === '5' ? 'step-selected': 'step-option'" step="5" color="black">
                <strong :class="step === '5' ? 'word-black' : 'word-white'"><b>Tesour. Pagamento</b></strong>
              </v-stepper-step>
            </v-stepper-header>
          </v-stepper>
          <v-row no-gutters>
            <v-col>
              <v-row class="pt-3" no-gutters>
                <v-col>
                  <h3>{{ itensSelecionados.length }} selecionado(s), totalizando R$
                    {{ valorTotalSelecionado }}:</h3>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                <span v-for="(item, index) in itensSelecionados" :key="index">
                   <b>{{ index + 1 }}- </b> Empresa: <b>{{ item.Empresa }}</b> -
                    Nota: <b>{{ item.Núm_NF }}</b> -
                    Documento: <b>{{ item.Documento }}</b> -
                    Valor: R$ <b>{{ item.Valor_parcela }}</b>
                    <v-tooltip right>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on"
                                @click="removerItem(item)">
                          mdi-close
                        </v-icon>
                      </template>
                      <span>Remover</span>
                    </v-tooltip>
                  <br>
                </span>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col>
                  <h3>Deseja movê-lo(s) para qual setor?</h3>
                </v-col>
              </v-row>
            </v-col>
            <v-col>
              <v-row justify="center" no-gutters class="py-3">
                <h3>Observação</h3>
              </v-row>
              <v-row justify="center" no-gutters>
                <v-col class="pb-3">
                  <vue-editor v-model='observacaoAtual'></vue-editor>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-end pa-4 pt-0">
          <v-btn color="primary" class="mr-2" @click="mover" width="120">
            <b>Mover</b>
            <v-icon class="ml-1">mdi-arrow-collapse-right</v-icon>
          </v-btn>
          <v-btn color="clean" style="color: white;" @click="cancelar">
            <b>Cancelar</b>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog width="400" persistent v-model="openSync">
      <v-card height="185" color="grey lighten-1">
        <v-card-title class="pa-4" style="color: black;">
          <h2 v-if="naoSincronizado">Sincronizando...</h2>
          <h2 v-else>Sincronizado!</h2>
        </v-card-title>
        <v-card-text class="pa-4 pt-0" style="color: black;">
          <div class="text-center" v-if="naoSincronizado">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>
          <div v-else>
            <span><b>Horário do início: </b>{{ formataDataVisualizacao(syncModel.horario_inicio) }}</span><br>
            <span><b>Horário do término: </b>{{ formataDataVisualizacao(syncModel.horario_fim) }}</span><br>
            <span><b>Quantidade de itens processados: </b>{{ syncModel.qtd_itens_processados }}</span><br>
          </div>
        </v-card-text>
        <v-card-actions class="justify-end pa-4 pt-0">
          <v-btn v-if="!naoSincronizado" color="clean" style="color: white;" @click="openSync = false">
            <v-icon>mdi-close</v-icon>
            <b>Fechar</b>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {VueEditor} from 'vue2-editor';
import PeriodoUtil from "@/util/periodo.util";
import ReceberService from "@/service/receber.service";
import SinalizacaoService from "@/service/sinalizacao.service";
import MovimentacaoService from "@/service/movimentacao.service";
import Listas from "../models/lists/listas.model";
import SinalizacaoResponse from "@/models/cliente/sinalizacao-response";
import ReceberResponse from "@/models/receber-response";
import ReceberFilterModel from "@/models/cliente/receber-filter.model";
import {mapActions} from "vuex";
import {MapActionsSnackbar} from "@/store/modules/snackbar/map-actions.snackbar";
import {MapActionsLoading} from "@/store/modules/loading/map-actions.loading";
import MovimentacaoRequest from "@/models/cliente/movimentacao-request";
import ItemMovimentacaoModel from "@/models/cliente/item-movimentacao.model";
import RulesUtil from "@/util/rules";

export default {
  name: "TitulosEmAbertoComponent",
  components: {
    VueEditor
  },
  data: () => ({
    headers: [],
    keyDataFim: 0,
    keyDataInicio: 0,
    listas: new Listas(),
    rules: RulesUtil,
    statusPendente: "PENDENTE",
    itensSelecionados: [],
    receberResponse: new ReceberResponse(),
    response: new SinalizacaoResponse(),
    filtroReceber: new ReceberFilterModel(),
    showDialogMover: false,
    showDialogHistorico: false,
    idCliente: 0,
    step: 0,
    observacaoAtual: '',
    valorTotalSelecionado: '',
    movimentacaoRequest: new MovimentacaoRequest(),
    historico: [],
    checkNexomed: true,
    checkBml: true,
    checkPendente: true,
    checkPago: false,
    naoSincronizado: true,
    openSync: false,
    periodoUtil: PeriodoUtil,
  }),
  methods: {
    ...mapActions("snackbar", [MapActionsSnackbar.SET_SNACKBAR_ERROR]),
    ...mapActions("loading", [MapActionsLoading.OPEN_LOADING, MapActionsLoading.CLOSE_LOADING]),
    validaRange() {
      if (this.filtroReceber.data_filtro) {
        if (this.filtroReceber.data_inicio && this.filtroReceber.data_fim) {
          return true;
        } else {
          this.setSnackbarError('É obrigatório informar a data de início e de fim!');
          return false;
        }
      }
      return true;
    },
    resetarModalMover() {
      this.step = 0;
      this.observacaoAtual = null;
    },
    cancelar() {
      this.showDialogMover = false;
      this.resetarModalMover();
    },
    async mover() {
      if (this.step > 0) {
        this.itensSelecionados.forEach(i => {
          this.movimentacaoRequest.itens.push(new ItemMovimentacaoModel(i.Documento, i.Núm_NF,
              this.formataDataServico(i.Data_emissão), i.Empresa, this.idCliente, i.Cód_Fornecedor,
              this.observacaoAtual, this.step));
        });
        await MovimentacaoService.mover(this.movimentacaoRequest);
        this.movimentacaoRequest.itens = [];
        this.itensSelecionados = [];
        this.showDialogMover = false;
        await this.buscarNotasDocumentos(true);
        this.resetarModalMover();
      } else {
        this.setSnackbarError('É obrigatório selecionar algum setor para mover!');
      }
    },
    formataDataServico(data) {
      if (data) {
        const [day, month, year] = data.substring(0, 10).split('/');
        return `${year}-${month}-${day}`;
      }
      return data;
    },
    formataDataVisualizacao(data) {
      if (data) {
        const [year, month, day] = data.substring(0, 10).split('-');
        return `${day}/${month}/${year}`;
      }
      return data;
    },
    async buscarNotasDocumentos(isMounted) {
      if (this.validaRange()) {
        if (this.response && this.response.cliente) {
          if (this.response.cliente.codigo) {
            this.filtroReceber.Cód_Fornecedor = this.response.cliente.codigo.toString();
          }
          if (!isMounted) {
            this.openLoading();
          }
          this.setaFiltroEmpresa();
          this.setaFiltroStatusPagamento();
          this.receberResponse = await ReceberService.localizar(this.filtroReceber);
          this.closeLoading();
        }
      }
    },
    setaFiltroEmpresa() {
      if (this.checkNexomed && this.checkBml) {
        this.filtroReceber.Empresa = null;
      } else if (this.checkNexomed && !this.checkBml) {
        this.filtroReceber.Empresa = 'Nexomed';
      } else if (!this.checkNexomed && this.checkBml) {
        this.filtroReceber.Empresa = 'BML';
      } else {
        this.filtroReceber.Empresa = null;
      }
    },
    setaFiltroStatusPagamento() {
      if (this.checkPendente && this.checkPago) {
        this.filtroReceber.status_pagamento = null;
      } else if (this.checkPendente && !this.checkPago) {
        this.filtroReceber.status_pagamento = this.statusPendente;
      } else if (!this.checkPendente && this.checkPago) {
        this.filtroReceber.status_pagamento = 'PAGO';
      } else {
        this.filtroReceber.status_pagamento = null;
      }
    },
    goMover() {
      if (this.itensSelecionados.length > 0) {
        let total = 0;
        this.itensSelecionados.forEach(i => {
          const valorAcumulado = parseFloat(total.toString().replace('.', '')
              .replace(',', '.'));
          const newValor = parseFloat(i.Valor_parcela.replace('.', '')
              .replace(',', '.'));
          total = (valorAcumulado + newValor).toLocaleString('pt-br', {minimumFractionDigits: 2});
        });
        this.valorTotalSelecionado = total;
        this.showDialogMover = true;
      } else {
        this.setSnackbarError('É necessário selecionar no mínimo 1 item');
      }
    },
    async goHistorico() {
      if (this.itensSelecionados.length === 1) {
        this.showDialogHistorico = true;
        const numDocumento = this.itensSelecionados[0].Documento;
        this.historico = await MovimentacaoService.getHistorico(numDocumento);
      } else {
        this.setSnackbarError('Selecione apenas 1 item');
      }
    },
    limpar() {
      this.keyDataInicio += 1;
      this.keyDataFim += 1;
      this.filtroReceber = new ReceberFilterModel();
    },
    removerItem(i) {
      this.indexDelete = this.itensSelecionados.indexOf(i);
      this.itensSelecionados.splice(this.indexDelete, 1);
      if (this.itensSelecionados.length === 0) {
        this.showDialogMover = false;
      } else {
        const vlAnterior = parseFloat(this.valorTotalSelecionado.replace('.', '')
            .replace(',', '.'));
        const vlRemovido = parseFloat(i.Valor_parcela.replace('.', '')
            .replace(',', '.'));
        const vlAtualizado = (vlAnterior - vlRemovido).toLocaleString('pt-br',
            {minimumFractionDigits: 2});
        this.valorTotalSelecionado = vlAtualizado;
      }
    },
    async goSync() {
      this.openSync = true;
      this.naoSincronizado = true;
      this.syncModel = await MovimentacaoService.sync();
      this.naoSincronizado = false;
      this.response = await SinalizacaoService.getAll(this.idCliente);
      this.filtroReceber.status_pagamento = this.statusPendente;
      await this.buscarNotasDocumentos(true);
    },
    itemRowBackground(itemRow) {
      if (itemRow.status_pagamento === 'PAGO') {
        return 'no-selected';
      }
      if (this.itensSelecionados.filter(i => i.Núm_NF === itemRow.Núm_NF).length === 0) {
        return 'pendente';
      } else {
        return 'selected';
      }
    },
    removerNotasPagas() {
      const qtdItens = this.receberResponse.itens.length;
      const qtditensSelecionadoss = this.itensSelecionados.length;
      if (qtdItens === qtditensSelecionadoss) {
        this.itensSelecionados = this.itensSelecionados.filter(i => i.status_pagamento === this.statusPendente);
      }
    }
  },
  watch: {
    "itensSelecionados": function (novo, velho) {
      if (novo !== velho) {
        this.removerNotasPagas();
      }
    },
  },
  async mounted() {
    this.headers = this.listas.headersSinalizacao;
    this.idCliente = parseInt(this.$route.params.id);
    this.response = await SinalizacaoService.getAll(this.idCliente);
    this.filtroReceber.status_pagamento = this.statusPendente;
    await this.buscarNotasDocumentos(true);
  },
}
</script>

<style>
.color-title {
  background-color: #353535;
  opacity: 0.4;
}

.v-data-table-header th {
  background-color: #008597 !important;
}

.selected td {
  font-weight: bold !important;
  border-bottom: 1px solid black !important;
}

.selected {
  background-color: white !important;
  color: black !important;
}

.selected .mdi-checkbox-marked {
  color: #008597 !important;
}

.selected .mdi-minus-circle-outline {
  color: black !important;
}

.no-selected {
  pointer-events: none !important;
}

.pendente .mdi-checkbox-blank-outline {
  color: #008597 !important;
}

.no-selected .mdi-checkbox-blank-outline {
  color: rgba(255, 255, 255, 0.12) !important;
}

.cor-paleta {
  color: #008597 !important;
}

.nomessage .v-text-field__details {
  display: none;
}

.check-nomessage .v-messages {
  display: none;
}

.step-option .v-stepper__step__step {
  background-color: white !important;
  color: black !important;
  font-weight: bold !important;
}

.step-selected .v-stepper__step__step {
  background-color: black !important;
  color: white !important;
  font-weight: bold !important;
}

.word-white {
  color: white;
}

.word-black {
  color: black;
}

.alinharColuna {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
</style>

<style scoped>
.v-data-table /deep/ .sticky-header {
  position: sticky;
  top: 0;
}

.v-data-table /deep/ .v-data-table__wrapper {
  overflow: unset;
}
</style>
